import { useLocation, useNavigate } from "react-router-dom";

export const useAuthNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get redirect path from location state or query params
  const getRedirectPath = () => {
    const from = location.state as
      | { from?: { pathname?: string; search?: string } }
      | undefined;

    if (from?.from?.pathname) {
      const search = from.from.search || "";
      return `${from.from.pathname}${search}`;
    }

    return new URLSearchParams(location.search).get("redirect") || "/";
  };

  // Navigate to intended destination after successful auth
  const navigateToDestination = (replace = true) => {
    const redirectPath = getRedirectPath();
    navigate(redirectPath, { replace });
  };

  // Navigate to register page with Google data
  const navigateToRegister = (googleData: unknown) => {
    navigate("/auth?tab=register", {
      state: {
        googleData,
        from: "google-login",
      },
    });
  };

  // Navigate to login page
  const navigateToLogin = () => {
    navigate("/auth?tab=login");
  };

  // Navigate to register page
  const navigateToRegisterPage = () => {
    navigate("/auth?tab=register");
  };

  // Navigate to forgot password page
  const navigateToForgotPassword = (method?: "email" | "phone") => {
    navigate(method ? `/forgot-password?method=${method}` : "/forgot-password");
  };

  return {
    getRedirectPath,
    navigateToDestination,
    navigateToRegister,
    navigateToLogin,
    navigateToRegisterPage,
    navigateToForgotPassword,
  };
};
